export interface CheckBoxInputTemplateProps {
  test?: any;
}

export const CheckBoxInputTemplate: React.FC<CheckBoxInputTemplateProps> = ({}) => {
  return <div />;
};
